import React, { Suspense, useEffect } from 'react';
import { Link, navigate, Router } from "@reach/router";
import { JStore } from '../context/interfaces';
import { useJourneyState } from '../context/JourneyContext';
import { Auth } from 'aws-amplify';
import { JourneyPage, JourneyProps } from "./Interfaces";
import processJourney from './processJourney';
export const MockTemplate: React.FC<any> = (props: JourneyPage) => <div><Link to={props.templateProps ? "/" + props.templateProps.nextScreen : "/"}><h2>MockTemplate</h2></Link>{JSON.stringify(props.templateProps)}</div>;

const Journey: React.FC<JourneyProps> = (props) => {
	const { setJourneyStore, journeyStore } = useJourneyState()
	let tempValues = { ...journeyStore } as JStore

	/**
	 * Initialize the journey context store to update values from the user flow
	 * Don't change anything below logic related to context store.
	 * This context store values by defualt empty ""
	 * It will initialize for nested journey too.
	 * Added by Goli - any doubts reached out Goli
	 * 
	 * If any changes happen to JSON structure then refactor/re-code to make it work
	 * with new structure or format.
	 */

	let fields = safelyGetNested(["goal", "fields"], props);
	if (fields) {
		const goalFields = Object.keys(fields);
		if (goalFields.length > 0) {
			goalFields.forEach(k => {
				if (Object.is(tempValues[k], undefined)) { tempValues[k] = "" };
			})
		}
	}

	//Pass user details to context API so they can be passed in mutation/query when calling backend.
	// useEffect(() => {
	// 	//console.log("journeyStore", journeyStore);
	// 	if (journeyStore && !journeyStore.hasOwnProperty('userInfo')) {
	// 		Auth.currentAuthenticatedUser().then(user => {
	// 			if (user) {
	// 				//Copy existing values and add or update user values.
	// 				tempValues = { ...tempValues, userInfo: user.attributes, username: user.attributes.name }
	// 				if (!isEquivalent(journeyStore || {}, tempValues)) { setJourneyStore(tempValues) }
	// 			}
	// 		}).catch(e => {
	// 			navigate("/login")
	// 		})
	// 	}
	// 	if (!isEquivalent(journeyStore || {}, tempValues)) { setJourneyStore(tempValues) }
	// }, [journeyStore])

	//This function builds the routes and links arrays.
	let { links, routes } = processJourney(props, journeyStore);
	//Comment this line (links = [];) out if you need to debug routes.
	//links = [];
	return <>
		{/* {<div>{links}</div>} */}
		<Suspense fallback={<div>Loading...</div>}>
			<Router style={{ textAlign: "center" }}>{routes}</Router>
		</Suspense>
	</>
}

function isEquivalent(a: object | JStore, b: object | JStore) {
	// Create arrays of property names
	var aProps = Object.getOwnPropertyNames(a);
	var bProps = Object.getOwnPropertyNames(b);

	// If number of properties is different, objects are not equivalent
	if (aProps.length != bProps.length) { return false; }
	// Iterate remaining properties to match each.
	for (var i = 0; i < aProps.length; i++) {
		var propName = aProps[i];
		//@ts-ignore
		if (a[propName] !== b[propName]) { return false; }
	}
	// If we made it this far, objects are considered equivalent
	return true;
}

const safelyGetNested = (path: any[], object: object) => path.reduce((xs: any, x: any) => (xs && xs[x]) ? xs[x] : null, object)

export default Journey;